import { isEqual } from 'lodash';
import useUnsavedValue from '../../../../StickyFilters/hooks/useUnsavedValue';

const useTagsDropdown = ({ propTags }) => {
    const {
        value: tags,
        setValue: setTags,
        isDifferent,
    } = useUnsavedValue({
        initialValue: propTags,
        comparator: (a, b) => isEqual([...a].sort(), [...b].sort()),
    });

    const handleRemoveTag = (tagToRemove) => () => {
        setTags((tags) => tags.filter((tag) => tag !== tagToRemove));
    };

    const handleClear = () => {
        setTags([]);
    };

    return {
        tags,
        setTags,
        canClear: !!tags.length,
        canApply: isDifferent,
        handleRemoveTag,
        handleClear,
    };
};

export default useTagsDropdown;
